import { Button as MortarButton } from '@policygenius/mortar';
import React, { MouseEventHandler, useCallback } from 'react';

import { frontendAnalyticsTrack } from 'analytics/utils';

import { CLICKED_BUTTON_EVENT } from './constants';
import { ButtonProps } from './types';

const Button: React.FC<ButtonProps> = ({
  analyticsProperties,
  fullWidth = true,
  onClick,
  size = 'large',
  variant = 'black',
  ...rest
}) => {
  const handleButtonClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
    (...args) => {
      const properties = {
        ...analyticsProperties,
      };

      frontendAnalyticsTrack(CLICKED_BUTTON_EVENT, properties);

      return onClick && onClick(...args);
    },
    [analyticsProperties, onClick]
  );

  return (
    <MortarButton
      fullWidth={fullWidth}
      onClick={handleButtonClick}
      size={size}
      variant={variant}
      {...rest}
    />
  );
};

export default Button;
